import { createSlice } from '@reduxjs/toolkit';
import { createIndependentStore } from '@utils/react';
import { getNextSortDirection } from './util.get-next-sort-direction.js';

const initialState = {
  sortedBy: "date",
  direction: "asc"
};
const slice = createSlice({
  name: "user-area/status",
  initialState,
  reducers: {
    sort(state, action) {
      state.sortedBy = action.payload;
      state.direction = getNextSortDirection(state, action.payload);
    }
  }
});
const statusStore = createIndependentStore(slice);

export { statusStore };
//# sourceMappingURL=state.store.js.map
